<template>
  <v-sheet color="grey800" class="px-4 py-2 grey200--text">
    <v-form v-model="valid" @submit.prevent="onSave">
      <v-row>
        <v-col cols="12" class="pb-0">
          <label
            v-t="'page.account.settings.trade_url.label'"
            for="fieldTradeUrl" class="grey100--text d-block font-weight-bold"
          />
          <i18n
            path="page.account.settings.trade_url.description"
            tag="p" class="body-2 lh-1-2 mb-3"
          >
            <a
              v-t="'common.here'"
              href="https://steamcommunity.com/my/tradeoffers/privacy#trade_offer_access_url" target="_blank" class="link primary500--text"
            />
          </i18n>

          <v-text-field
            id="fieldTradeUrl" v-model="input" :rules="rules"
            placeholder="https://steamcommunity.com/..."
            class="settings-btn rounded-0"
            dense solo flat
            background-color="grey600"
          >
            <template #append-outer>
              <v-btn
                v-t="'cta.save'"
                class="px-8 font-weight-semibold text-caption green500--text rounded-0" color="green800"
                height="38" :ripple="false"
                depressed
                :disabled="!valid"
                :loading="loading"
                @click="onSave"
              />
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </v-form>
  </v-sheet>
</template>

<script>
import { TRADEURL_RE } from '@/utils/constants/regexes'
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    loading: Boolean,
  },
  data() {
    return {
      valid: false,
      input: this.value,
      rules: [
        v => !!v || 'Required',
        v => TRADEURL_RE.test(v) || 'Invalid Trade URL.',
      ],
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/session',
    }),
  },
  methods: {
    onSave() {
      if (!this.valid) return
      this.$emit('update', this.input)
    },
  },
}
</script>

<style lang="scss" scoped>
  ::v-deep .settings-btn {
    .v-input__append-outer {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }
  }
</style>
